import { SxProps, Theme } from '@mui/system';

const styles = {
  fieldContainer: {
    display: 'flex',
    gap: '23px',
    mt: '24px',
  },
  labelStyle: {
    wordWrap: 'normal',
    whiteSpace: 'normal',
    fontSize: 12,
    textAlign: 'left',
    minWidth: '80px',
  },
  zeroMargin: {
    m: 0,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
